// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-message {
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 8px;
  max-width: 85%;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.user-message {
  background-color: #e3f2fd;
  margin-left: auto;
  border-bottom-right-radius: 4px;
}

.assistant-message {
  background-color: #f5f5f5;
  margin-right: auto;
  border-bottom-left-radius: 4px;
}

.message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #757575;
}

.message-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.message-role {
  font-weight: 500;
  color: #424242;
}

.message-time {
  margin-left: auto;
  font-size: 11px;
}

.message-content {
  color: #212121;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.message-content p {
  margin: 0;
}
.message-content ::ng-deep strong {
  font-weight: 600;
  color: #1a1a1a;
}
.message-content ::ng-deep em {
  font-style: italic;
}
.message-content ::ng-deep code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: "Courier New", monospace;
  font-size: 0.9em;
  color: #d32f2f;
}
.message-content ::ng-deep ul {
  margin: 8px 0;
  padding-left: 20px;
  list-style-type: disc;
}
.message-content ::ng-deep li {
  margin: 4px 0;
}
.message-content ::ng-deep a {
  color: #1976d2;
  text-decoration: none;
}
.message-content ::ng-deep a:hover {
  text-decoration: underline;
}

.inline-job-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  color: #5f6b72;
  font-size: 11px;
  line-height: 1.3;
}
.inline-job-status__dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: #d18b00;
}
.inline-job-status__link {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0066a1;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.inline-job-status__link:hover {
  text-decoration: underline;
}
.inline-job-status--complete .inline-job-status__dot {
  background: #218739;
}

.markdown-table-container {
  margin: 16px 0;
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.markdown-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 13px;
}
.markdown-table thead {
  background: #f5f5f5;
}
.markdown-table thead th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #424242;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
}
.markdown-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}
.markdown-table tbody tr:hover {
  background-color: #fafafa;
}
.markdown-table tbody tr:last-child {
  border-bottom: none;
}
.markdown-table tbody td {
  padding: 10px 16px;
  color: #616161;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.markdown-table tbody td:first-child {
  font-weight: 500;
  color: #424242;
}

.message-sources {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.sources-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #616161;
  margin-bottom: 8px;
}
.sources-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.sources-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.source-chip {
  cursor: pointer;
  font-size: 12px;
}
.source-chip:hover {
  background-color: #1976d2 !important;
  color: white;
}

.sources-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #1976d2;
  transition: all 0.2s ease;
}
.sources-toggle-btn:hover {
  background-color: #e3f2fd;
  border-color: #1976d2;
}
.sources-toggle-btn:active {
  background-color: #bbdefb;
}
.sources-toggle-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

::ng-deep .source-chip mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.streaming-cursor {
  display: inline-block;
  width: 2px;
  height: 1em;
  background: currentColor;
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: blink-cursor 0.8s step-end infinite;
}

@keyframes blink-cursor {
  50% {
    opacity: 0;
  }
}
.quick-replies {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.quick-replies .quick-reply-chip {
  font-size: 12px;
  line-height: 1.35;
  min-height: 34px;
  height: auto;
  padding: 8px 12px;
  border-radius: 16px;
  border-color: #1565c0;
  color: #1565c0;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  display: inline-flex;
  align-items: center;
}
.quick-replies .quick-reply-chip:hover {
  background-color: #e3f2fd;
}

.action-links {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.action-links .action-link-btn {
  font-size: 13px;
}
.action-links .action-link-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/chat/chat-message/chat-message.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,yBAAA;EACA,iBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAAF;AAEE;EACE,SAAA;AAAJ;AAKI;EACE,gBAAA;EACA,cAAA;AAHN;AAMI;EACE,kBAAA;AAJN;AAOI;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAAA;AALN;AAQI;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AANN;AASI;EACE,aAAA;AAPN;AAUI;EACE,cAAA;EACA,qBAAA;AARN;AAUM;EACE,0BAAA;AARR;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXF;AAaE;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AAcI;EACE,0BAAA;AAZN;AAgBE;EACE,mBAAA;AAdJ;;AAkBA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AAfF;;AAkBA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AAfN;AAoBI;EACE,gCAAA;EACA,iCAAA;AAlBN;AAoBM;EACE,yBAAA;AAlBR;AAqBM;EACE,mBAAA;AAnBR;AAuBI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AArBN;AAuBM;EACE,gBAAA;EACA,cAAA;AArBR;;AA4BA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzBJ;;AA6BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,eAAA;AA1BF;AA4BE;EACE,oCAAA;EACA,YAAA;AA1BJ;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AA3BF;AA6BE;EACE,yBAAA;EACA,qBAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7BJ;;AAiCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAkCA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8CAAA;AA/BF;;AAkCA;EACE;IAAM,UAAA;EA9BN;AACF;AAiCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AA/BF;AAiCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AA/BJ;AAiCI;EACE,yBAAA;AA/BN;;AAqCA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAlCF;AAoCE;EACE,eAAA;AAlCJ;AAoCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAlCN","sourcesContent":[".chat-message {\n  margin-bottom: 16px;\n  padding: 12px;\n  border-radius: 8px;\n  max-width: 85%;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-message {\n  background-color: #e3f2fd;\n  margin-left: auto;\n  border-bottom-right-radius: 4px;\n}\n\n.assistant-message {\n  background-color: #f5f5f5;\n  margin-right: auto;\n  border-bottom-left-radius: 4px;\n}\n\n.message-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #757575;\n}\n\n.message-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n}\n\n.message-role {\n  font-weight: 500;\n  color: #424242;\n}\n\n.message-time {\n  margin-left: auto;\n  font-size: 11px;\n}\n\n.message-content {\n  color: #212121;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n\n  p {\n    margin: 0;\n  }\n\n  // Markdown styling\n  ::ng-deep {\n    strong {\n      font-weight: 600;\n      color: #1a1a1a;\n    }\n\n    em {\n      font-style: italic;\n    }\n\n    code {\n      background-color: #f5f5f5;\n      padding: 2px 6px;\n      border-radius: 3px;\n      font-family: 'Courier New', monospace;\n      font-size: 0.9em;\n      color: #d32f2f;\n    }\n\n    ul {\n      margin: 8px 0;\n      padding-left: 20px;\n      list-style-type: disc;\n    }\n\n    li {\n      margin: 4px 0;\n    }\n\n    a {\n      color: #1976d2;\n      text-decoration: none;\n      \n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.inline-job-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  color: #5f6b72;\n  font-size: 11px;\n  line-height: 1.3;\n\n  &__dot {\n    width: 7px;\n    height: 7px;\n    flex: 0 0 7px;\n    border-radius: 50%;\n    background: #d18b00;\n  }\n\n  &__link {\n    margin-left: auto;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #0066a1;\n    font: inherit;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &--complete .inline-job-status__dot {\n    background: #218739;\n  }\n}\n\n.markdown-table-container {\n  margin: 16px 0;\n  overflow-x: auto;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.markdown-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  font-size: 13px;\n  \n  thead {\n    background: #f5f5f5;\n    \n    th {\n      padding: 12px 16px;\n      text-align: left;\n      font-weight: 600;\n      color: #424242;\n      border-bottom: 2px solid #e0e0e0;\n      white-space: nowrap;\n    }\n  }\n  \n  tbody {\n    tr {\n      border-bottom: 1px solid #e0e0e0;\n      transition: background-color 0.2s;\n      \n      &:hover {\n        background-color: #fafafa;\n      }\n      \n      &:last-child {\n        border-bottom: none;\n      }\n    }\n    \n    td {\n      padding: 10px 16px;\n      color: #616161;\n      max-width: 250px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      \n      &:first-child {\n        font-weight: 500;\n        color: #424242;\n      }\n    }\n  }\n}\n\n\n.message-sources {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.sources-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #616161;\n  margin-bottom: 8px;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.sources-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.source-chip {\n  cursor: pointer;\n  font-size: 12px;\n  \n  &:hover {\n    background-color: #1976d2 !important;\n    color: white;\n  }\n}\n\n.sources-toggle-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #1976d2;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #e3f2fd;\n    border-color: #1976d2;\n  }\n\n  &:active {\n    background-color: #bbdefb;\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n::ng-deep .source-chip mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n// Blinking cursor shown while streaming\n.streaming-cursor {\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  background: currentColor;\n  margin-left: 2px;\n  vertical-align: text-bottom;\n  animation: blink-cursor 0.8s step-end infinite;\n}\n\n@keyframes blink-cursor {\n  50% { opacity: 0; }\n}\n\n// Quick-reply chips for repo/branch selection\n.quick-replies {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n\n  .quick-reply-chip {\n    font-size: 12px;\n    line-height: 1.35;\n    min-height: 34px;\n    height: auto;\n    padding: 8px 12px;\n    border-radius: 16px;\n    border-color: #1565c0;\n    color: #1565c0;\n    white-space: normal;\n    word-break: break-word;\n    text-align: left;\n    display: inline-flex;\n    align-items: center;\n\n    &:hover {\n      background-color: #e3f2fd;\n    }\n  }\n}\n\n// Action links (e.g. \"View Assessment Results\")\n.action-links {\n  margin-top: 10px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  .action-link-btn {\n    font-size: 13px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      margin-right: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
